export default function initNavLinks() {
  const body = document.body;
  const header = document.querySelector('.header');
  const nav = header?.querySelector('.nav');
  const navLinks = nav?.querySelectorAll('a');
  const activeClass = 'nav-active';

  // Track if menu was active before resizing
  let wasMenuActiveOnMobile = false;
  const MOBILE_BREAKPOINT = 1024;

  // Click nav link: close menu on mobile
  navLinks?.forEach((link) => {
    link.addEventListener('click', () => {
      if (body.classList.contains(activeClass)) {
        body.classList.remove(activeClass);
      }
    });
  });

  // Handle resize
  function handleResize() {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    if (!isMobile && body.classList.contains(activeClass)) {
      // Exiting mobile view, remove menu
      wasMenuActiveOnMobile = true;
      body.classList.remove(activeClass);
    } else if (isMobile && wasMenuActiveOnMobile) {
      // Back to mobile, restore menu
      body.classList.add(activeClass);
      wasMenuActiveOnMobile = false; // Reset flag
    }
  }

  // Initial check
  window.addEventListener('resize', handleResize);
}
